/* eslint-disable import/no-cycle */
import React from 'react';
import PropTypes from 'prop-types';

const WsVideoBlock = ({ config }) => <></>;

WsVideoBlock.propTypes = { config: PropTypes.object };

export default WsVideoBlock;
